export const setLocalStorageItem = (itemKey, itemValue) => {
  if (typeof window !== 'undefined' && window.localStorage) {
    window.localStorage.setItem(itemKey, JSON.stringify(itemValue))
  }
}

export const getLocalStorageItem = (itemKey, defaultValue) => {
  if (typeof window !== 'undefined' && window.localStorage) {
    return JSON.parse(window.localStorage.getItem(itemKey)) || defaultValue
  } else {
    return defaultValue
  }
}



// WEBPACK FOOTER //
// ./common/utils/localStorageHelpers.js